import React from 'react';

export default function CloseButton({ onClick, style = {}, ariaLabel = "Close", position = "fixed", top = 20, right = 20, zIndex = 9999 }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        position,
        top,
        right,
        background: 'rgba(0,0,0,0.6)',
        border: 'none',
        color: '#fff',
        fontSize: '2.5rem',
        cursor: 'pointer',
        zIndex,
        boxShadow: '0 2px 16px rgba(0,0,0,0.25)',
        borderRadius: '50%',
        width: 56,
        height: 56,
        lineHeight: '56px',
        textAlign: 'center',
        padding: 0,
        ...style,
      }}
      aria-label={ariaLabel}
    >×</button>
  );
}